import React from "react";
import { motion } from "framer-motion";
import { useLang } from "../i18n";

export default function Gallery({ content }) {
  const { t, lang } = useLang();
  const items = content.gallery || [];

  return (
    <section id="work" className="relative z-10 bg-[#050505] py-24 sm:py-32">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="mb-14 max-w-2xl">
          <div className="font-mono2 text-xs uppercase tracking-[0.3em] text-primary-red mb-4">/ {t.gallery.kicker}</div>
          <h2 className="font-display uppercase text-4xl sm:text-6xl text-white leading-[0.95]">{t.gallery.title}</h2>
          <p className="mt-5 font-body text-lg text-neutral-400">{t.gallery.sub}</p>
        </div>

        {items.length === 0 ? (
          <div className="border border-white/10 p-16 text-center font-body text-neutral-500">No images yet.</div>
        ) : (
          <div className="grid grid-cols-2 lg:grid-cols-3 gap-4">
            {items.map((g, i) => (
              <motion.div
                key={g.id || i}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-40px" }}
                transition={{ duration: 0.5, delay: (i % 3) * 0.08 }}
                className={`group relative overflow-hidden bg-[#0a0a0a] ${i % 5 === 0 ? "lg:col-span-2 lg:row-span-2" : ""}`}
                data-testid={`gallery-${i}`}
              >
                <img
                  src={g.url}
                  alt={(lang === "en" ? g.caption_en : g.caption_es) || "Work"}
                  className="w-full h-full min-h-[220px] object-cover grayscale group-hover:grayscale-0 scale-105 group-hover:scale-100 transition-all duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                {(g.caption_en || g.caption_es) && (
                  <div className="absolute bottom-4 left-4 font-display uppercase text-xl text-white opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    {lang === "en" ? g.caption_en : g.caption_es}
                  </div>
                )}
              </motion.div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
